import React from "react";
import { YellowButton } from "../buttons";

const BalanceAndUnlock = ({
  userBalance,
  yourWallet,
  unlockPath,
  coinsBalanceText,
  unlockEpisodeNow,
  enoughCoins
}) => (
  <div>
    <div className="flex justify-center items-center">
      <p className="lh-title t-mv1">
        {" "}
        {yourWallet}:{" "}
        <strong className={`${enoughCoins ? "green-4" : "red-4"}`}>
          {userBalance}
        </strong>{" "}
      </p>
      <img
        className="t-ml1 db grow"
        src="/images/ic-cre8.svg"
        width="24"
        height="24"
      />
    </div>
    <p className={enoughCoins ? "green-4" : "red-4"}>
      {!enoughCoins && (
        <img
          className="dib t-pr1 v-top"
          src="/images/alert-red.svg"
          width="18"
          height="18"
        />
      )}
      {coinsBalanceText}
    </p>
    {enoughCoins && (
      <div className="t-pt3">
        <YellowButton
          className="border-none heartbeat-5 ttc"
          path={unlockPath}
          text={unlockEpisodeNow}
          onClick={() => false}
        />
      </div>
    )}
  </div>
);

BalanceAndUnlock.defaultProps = {
  episodePrice: 0,
  userBalance: 0,
  yourWallet: "EN yourWallet",
  coinsBalanceText: "EN Not enough coins",
  unlockEpisodeNow: "EN Unlock episode now",
  enoughCoins: false,
  unlockPath: "#/unlock"
};

export default BalanceAndUnlock;
